<template>
  <div style="width: 100%;">
    <!--   图片 -->

    <img
      src="http://pic.midongtech.xyz/yytgw/assets/img_App_popularize_img_banner_fir.jpg"
      style="width: 100vw;height: 20vw;margin-top:2px;"
    />
    <!--  用户获取-->

    <div v-if="ISphone" class="fx-column fx-row-center">
      <img
        src="http://pic.midongtech.xyz/yytgw/assets/img_App_popularize_img_source_ph.png"
        style="width: 80vw; margin-top:5vw;"
      />

      <!-- smallh2label  bigh2label -->
      <div
        @click="jumptocontanctus"
        style=" margin-top:5vw; margin-bottom:8vw; "
        class="darkbuttoncolor hvr_grow_shadow"
        :class="ISphone ? 'pushbutton_phone' : 'pushbutton1'"
      >联系我们</div>
    </div>

    <div v-else class="fx-column fx-row-center" style="width: 100vw; background: white;">
      <div :class="ISphone ? smallh1label : bigh1label" style="margin-top: 5vw;">什么是用户获取</div>

      <div class="blueline"></div>

      <div
        :class="ISphone ? smallh2label : bigh3label"
        style="width: 56vw; margin-top: 3vw; color:#515978; "
      >愉悦推基于DMP数据库积累及实时数据分析技术，智能分类用户标签，帮助广告主选择符合目标受众的人群，定向投放移动广告，实现精准优质用户的快速获取</div>

      <div
        class="fx-row fx-row-top fx-row-space-between"
        style="width: 60vw;  margin-top: 3vw; margin-bottom: 5vw;"
      >
        <div
          class="fx-column fx-row-center"
          v-for="(item, index) in numbersarray"
          v-bind:key="index"
        >
          <div :class="ISphone ? smallh2label : 'pxlabel_60'" class="redbigtitle">{{ item.count }}</div>
          <div :class="ISphone ? smallh3label : bigh3label" class="usercelldes">{{ item.des }}</div>
        </div>
      </div>
    </div>

    <!--      方案-->

    <!-- img_App_popularize_img_type_ph -->
    <img
      v-if="ISphone"
      src="http://pic.midongtech.xyz/yytgw/assets/img_App_popularize_img_type.png"
      style="width: 100vw;"
    />

    <div v-else class="plan fx-column fx-row-center">
      <div
        :class="ISphone ? smallh1label : bigh2label"
        style="margin-top: 3vw; margin-bottom: 4vw; color:#515978;"
      >根据客户及产品需求，定制与实施精准移动营销方案</div>

      <!-- <div class="blueline"></div> -->

      <div class="plantable fx-row fx-row-center fx-row-space-between">
        <div
          class="plancell hvr_grow_shadow fx-column fx-row-center"
          v-for="(item, index) in planarray"
          v-bind:key="index"
        >
          <img class="plancell_icon" :src="item.iconurl" />
          <div
            :class="ISphone ? smallh2label : 'pxlabel_20'"
            class="plancell_name"
            style="color:#16214B;"
          >{{ item.titlestr }}</div>
          <div
            :class="ISphone ? smallh3label : bigh3label"
            class="plancell_des"
            style="color:#515978;"
          >{{ item.desstr }}</div>
        </div>
      </div>
    </div>

    <!--  广告形式  -->
    <!--   adstyle_table  adstyle_cell cell_letfstyle  cell_rightstyle  -->
    <div class="adstyle_table fx-column fx-row-center">
      <div
        class="adstyle_cell fx-column fx-row-center"
        v-for="(item, index) in ADstylearray"
        v-bind:key="index"
      >
        <div class="cell_letfstyle fx-row fx-row-center" v-if="item.iconleft">
          <!--                 adstyle_cell_icon  adstyle_cell_labels  -->
          <!--                    //      adformstr   adway    -->
          <img :src="item.iconurl" class="adstyle_cell_icon" style="margin-left: 10vw;" />
          <div class="adstyle_cell_labels fx-column fx-row-center">
            <div
              :class="ISphone ? smallh1label : 'pxlabel_48'"
              class="adstyle_cell_label1"
              style="color:#16214B;"
            >{{item.titlestr}}</div>
            <div
              :class="ISphone ? smallh2label : 'pxlabel_20'"
              class="adstyle_cell_label2"
              style="color:#515978;"
            >{{item.adformstr}}</div>
            <div
              :class="ISphone ? smallh2label : 'pxlabel_20'"
              class="adstyle_cell_label3"
              style="color:#515978;"
            >{{item.adway}}</div>
          </div>
        </div>

        <div class="cell_rightstyle fx-row fx-row-center" v-else>
          <div class="adstyle_cell_labels fx-column fx-row-center" style="margin-left: 10vw;">
            <div
              :class="ISphone ? smallh1label : 'pxlabel_48'"
              class="adstyle_cell_label1"
              style="color:#16214B;"
            >{{item.titlestr}}</div>
            <div
              :class="ISphone ? smallh2label : 'pxlabel_20'"
              class="adstyle_cell_label2"
              style="color:#515978;"
            >{{item.adformstr}}</div>
            <div
              :class="ISphone ? smallh2label : 'pxlabel_20'"
              class="adstyle_cell_label3"
              style="color:#515978;"
            >{{item.adway}}</div>
          </div>

          <img :src="item.iconurl" class="adstyle_cell_icon" />
        </div>
      </div>
      <div style="background:black; width;100%;height:1px;"></div>
    </div>
    <!--    联系我们  -->

    <contactusview />
  </div>
</template>
<script type="text/ecmascript-6">
import contactusview from "@/components/contactusview.vue";

export default {
  name: "Extension",
  components: {
    contactusview
  },
  data() {
    return {
      ISphone: false,

      bigh1label: "bigh1label",
      bigh2label: "bigh2label",
      bigh3label: "bigh3label",
      smallh1label: "smallh1label",
      smallh2label: "smallh2label",
      smallh3label: "smallh3label",
      numbersarray: [
        {
          count: "1W+",
          des: "服务广告主数量"
        },
        {
          count: "6亿",
          des: "覆盖智能设备数"
        },
        {
          count: "10W",
          des: "覆盖APP数量"
        }
      ],
      //     img_spread_img_ad_fir
      //     img_App_popularize_img_advantage_sec
      //     img_App_popularize_img_advantage_thir
      // img_App_popularize_img_advantage_fir
      planarray: [
        {
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_App_popularize_img_advantage_fir2.png",
          titlestr: "流量保障",
          desstr: "千万用户精准画像，真实优质用户基础，强大流量抓取能力"
        },
        {
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_App_popularize_img_advantage_sec2.png",
          titlestr: "数据分析",
          desstr: "人工智能机器学习技术，海量数据挖掘分析，基于效果推荐算法"
        },
        {
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_App_popularize_img_advantage_thir2.png",
          titlestr: "精准定向",
          desstr: "多元化广告形式，根据广告选择投放渠道，多维定向效果精准"
        }
      ],
      ADstylearray: [
        {
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_App_type_img_ad_fir.png",
          titlestr: "开屏广告",
          adformstr: "投放形式：静态/动态/视频",
          adway: "投放方式：CPM、CPT",
          iconleft: false
        },
        {
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_App_type_img_ad_sec.png",
          titlestr: "头条置顶推荐",
          adformstr: "投放形式：大图/小图/组图",
          adway: "投放方式：CPT",
          iconleft: true
        },
        {
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_App_type_img_ad_thir.png",
          titlestr: "Banner广告",
          adformstr: "投放形式：JPG/PNG/GIF+文字",
          adway: "投放方式：CPT",
          iconleft: false
        },
        {
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_App_type_img_ad_four.png",
          titlestr: "信息流广告",
          adformstr:
            "采用HTML5与流媒体技术，让用户在移动设备上享受到沉浸式、高聚焦的视听享受，使广告主的优质创意与APP实现无缝植入。特别适合有视频传播需求的品牌，可投放到指定标签的用户，实现品牌精准传达和渗透",
          adway: "",
          iconleft: true
        }
      ]
    };
  },
  mounted() {
    this.ISphone = this.$appdata.ISphone;
  },
  methods: {
    /**
     * 点击事件
     */

    jumptocontanctus() {
      //  跳入联系我们
      //push jump
      this.$router.push({
        path: "/ContactUs"
      });
    }
    /**
     * 网络请求
     */
    /**
     * 业务方法
     */
    /**
     * 回调方法
     */
    /**
     * 页面私有方法
     */
  }
};
</script>
<style lang="less" scoped>
/*页面公共样式*/

// .redbiglabel {
//   font-size: 2.5vw;
// }

.redbigtitle {
  font-family: PingFang-SC-Semibold;
  // font-size: 2.5vw;
  color: #ff496a;
  /*letter-spacing: 0.71px;*/
  // width: 7.8vw;
  // height: 6vw;
  line-height: 6vw;
  font-weight: bold;
}

.usercelldes {
  width: 8vw;
  // height: 1.5vw;
  /*font-family: PingFang-SC-Regular;*/
  // font-size: 0.5vw;
  color: #16214b;
  letter-spacing: 0.17px;
}

.plan {
  background: #f3f4f6;
  width: 100vw;
}
.plantitle {
  width: 28vw;

  margin-top: 4.2vw;
  text-align: center;
  margin-bottom: 4vw;
}

.plantable {
  width: 80vw;
  margin-bottom: 4vw;
}
.plancell {
  width: 25vw;
  background: #ffffff;
  box-shadow: 0 21px 43px 0 rgba(22, 33, 75, 0.15);
  border-radius: 4px;
  padding-top: 1vw;
  padding-bottom: 1vw;
}
.plancell_icon {
  width: 9.43vw;
  height: 9.43vw;
  margin-top: 3vw;
}
.plancell_name {
  margin-top: 1.2vw;
  text-align: center;
  font-weight: middle;
  color: #16214b;
}

.plancell_des {
  margin-top: 1.4vw;
  margin-bottom: 4vw;
  width: 18.2vw;
  text-align: center;
  color: #515978;
}
/*  <!--   adstyle_table  adstyle_cell cell_letfstyle  cell_rightstyle  -->   */

.adstyle_table {
  width: 100vw;
}

.adstyle_cell {
  width: 100vw;
}

.cell_letfstyle {
  background: #f3f4f6;

  // background: red;

  width: 100vw;
}

.cell_rightstyle {
  background: white;
  width: 100vw;
}

/*  <!--                 adstyle_cell_icon  adstyle_cell_labels  -->  */

.adstyle_cell_icon {
  width: 40vw;
  // height: 40vw;
  margin-top: 3.5vw;
  margin-bottom: 3.5vw;

  /*box-shadow: 0 21px 43px 0 rgba(22,33,75,0.15);*/
  /*border-radius: 4px;*/

  // background: yellow;
}
.adstyle_cell_labels {
  width: 40vw;
  // height: 40vw;
  margin-top: 3.5vw;
  margin-bottom: 3.5vw;
  // background: green;
}

.adstyle_cell_label1 {
  width: 30vw;
  // height: 5vw;
  /*background: #0275d8;*/
  text-align: left;
  // font-size: 2vw;
  line-height: 5vw;
  margin-top: 5vw;

  color: black;
  // font-weight: bold;
}

.adstyle_cell_label2 {
  width: 30vw;
  text-align: left;
  //  font-size: 1.5vw;
  margin-top: 2vw;
  // font-weight: bold;
}
.adstyle_cell_label3 {
  width: 30vw;
  text-align: left;
  // font-size: 1.5vw;
  margin-top: 1vw;
  // font-weight: bold;
}
</style>
